
import { InputText as PrimereactInputText } from 'primereact/inputtext';
import { ReactComponent as ValidationErrorIcon } from '../../assets/images/validation-error.svg';
import { classNames } from 'primereact/utils';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

const InputText = ({showLabel = true, label, leftIcon, inputClassName, validator, validations, autoComplete = 'off', ...rest}) => {
    const id = `text-${rest.id}`;
    const validationMessage = validator ? validator.message(id, label, rest.value, validations) : null;

    const input = (
        <PrimereactInputText
            {...rest}
            id={id}
            className={classNames('w-full', {'p-invalid': validationMessage}, inputClassName)}
            autoComplete={autoComplete}
        />
    );

    const renderIcon = () => {
        if (typeof leftIcon === 'string') {
            return <i className={leftIcon} />;
        }
        // Dla SVG ikon - opakuj w span z odpowiednimi stylami
        if (leftIcon) {
            return (
                <span style={{ display: 'block', height: '1.25rem', width: '1.25rem', marginTop: '-0.25rem' }}>
                    {leftIcon}
                </span>
            );
        }
        return leftIcon;
    };

    return (
        <div className="field">
            {showLabel && <label htmlFor={id}>{label}</label>}
            {leftIcon ? (
                <IconField iconPosition='left'>
                    <InputIcon>{renderIcon()}</InputIcon>
                    {input}
                </IconField>
            ) : input}
            
            {validationMessage && <div className={"validation-error"}>
                <ValidationErrorIcon className='icon'/>
                <div className="text">{validationMessage}</div>
            </div>}
        </div>
    )
}

export default InputText;